import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


const Footer: React.FC = () => (
    <footer className="footer">
        <div className="footer-content">
            <p>
                43537 Ridge Park Drive Suite #100<br/>
                Temecula, CA 92590 <br/>
                (951) 840-1541
            </p>
            <div className="footer-right">
                <nav className="footer-nav">
                    <Link to="/">Home</Link>
                    <Link to="/about">About</Link>
                    <Link to="/practice-areas">Practice Areas</Link>
                    <Link to="/team">Team</Link>
                    <Link to="/blog">Blog</Link>
                    <Link to="/client-intake">Client Intake</Link>
                </nav>
                <div className="footer-row-2">
                    <p className="footer-nav"><Link to="/privacy-policy">Privacy Policy</Link></p>
                    <p>©{new Date().getFullYear()} Consumer Equity Legal </p>

                </div>
            </div>
        </div>
    </footer>
);

export default Footer;